import React from "react";
import { Box, Theme, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Investment } from "@rentablo/api/apiv1";
import { InvestmentChart } from "@components";
import { RangeSelectorControlProps } from "@hooks";
import { useChartData } from "../../../hooks/useChartData";

export const CHART_TAB_DATE_RANGES: IntervalType[] = [
  "oneDay",
  "oneWeek",
  "oneMonth",
  "YTD",
  "oneYear",
  "threeYears",
  "sinceBeginning",
];

interface Props {
  investment: Investment;
  rangeProps: RangeSelectorControlProps;
  hideRangeSelector?: boolean;
}

export const ChartTab = ({
  investment,
  rangeProps,
  hideRangeSelector = false,
}: Props) => {
  const { t } = useTranslation();

  const isLessMd = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  const {
    data: chartData = [],
    isFetching,
    isPending,
  } = useChartData({
    investmentId: investment.id,
    currentInterval: rangeProps.intervalType,
    startDate: rangeProps.range.startDate,
    endDate: rangeProps.range.endDate,
    tickerSymbol: investment.tickerSymbol,
    tickerSymbolWithCurrency: investment.tickerSymbolWithCurrency,
    quoteProvider: investment.quoteProvider,
  });

  return (
    <Box
      px={4}
      pt={isLessMd ? (hideRangeSelector ? 4 : 0) : 3}
      sx={{
        "& .highcharts-axis-labels text": { fontSize: "12px !important" },
      }}
    >
      <InvestmentChart
        data={chartData}
        isFetching={isFetching || isPending}
        rangeProps={rangeProps}
        hideControls={hideRangeSelector}
        availableDateRanges={CHART_TAB_DATE_RANGES}
        availableCompactDateRanges={CHART_TAB_DATE_RANGES}
        showNavigator={false}
        drawLines={false}
        chartHeight={240}
        noDataMessage={
          !isPending
            ? t("domains.investments.investmentTable.detailModal.noPriceData")
            : undefined
        }
      />
    </Box>
  );
};
